<template>
  <div class="component-wrap">
    <div class="add-new-wrap">
      <label>Add New: </label>
      <select v-model="location">
        <option v-for="(location, index) in editableMenus" :value="location" :key="index">
          {{location.menu_name}}
        </option>
      </select>
    </div>
    <add-or-edit-location
      v-if="location"
      :location="{ltp_code: location.ltp_code}"
      :floors="floors"
      @close-modal="$emit('close-modal')"
      @get-locations="$emit('get-locations')"
    ></add-or-edit-location>
  </div>
</template>

<script>
import AddOrEditLocation from './AddOrEditLocation';
import AdminMixin from '../../../views/admin-pages/adminMixin.js'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    AddOrEditLocation
  },
  props: {
    locations: Array,
    floors: Array
  },
  data () {
    return {
      location: ''
    }
  },
  computed: {
    editableMenus () {
      let editableMenus = [];
      for (let i = 0; i < this.locations.length; i++) {
        if (this.locations[i].ltp_code !== 'intr' && this.locations[i].ltp_code !== 'info') {
          editableMenus.push(this.locations[i]);
        }
      }
      return editableMenus;
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.add-new-wrap {
  display: flex;
  justify-content: center;
}
.edit-booths-wrap {
  width: 100%;
}
</style>